import React from 'react'
import PropTypes from 'prop-types'

import Logo from 'common/Logo'
import HeaderLink from './link'
import Hamburger from './hamburger'
import SideNav from 'views/Global/SideNav'

const Links = props => {
  const baseClass = 'flex items-center h-100'
  return (
    <nav className='dn flex-l h-100'>
      <HeaderLink to='/'
        className={`${baseClass} ${props.color} mr4`}
      >Welcome</HeaderLink>
      <HeaderLink to='/departments'
        className={`${baseClass} ${props.color} mr4`}
      >Departments</HeaderLink>
      <HeaderLink to='/locations'
        className={`${baseClass} ${props.color}`}
      >Locations</HeaderLink>
    </nav>
  )
}

export default class Header extends React.Component {
  static propTypes = {
    isOpaque: PropTypes.bool,
    onClickHamburger: PropTypes.func,
  }

  static defaultProps = {
    isOpaque: false,
  }

  state = {
    showMobileNav: false,
  }

  getTextColor () {
    return this.props.isOpaque ? 'black' : 'white'
  }

  onClickHamburger = () => {
    if (this.props.onClickHamburger) {
      this.props.onClickHamburger(!this.state.showMobileNav)
    }

    this.setState(state => ({
      showMobileNav: !state.showMobileNav,
    }))
  }

  render () {
    const textColor = this.getTextColor()

    return [
      <SideNav key='sidenav' isShown={this.state.showMobileNav} onClickOverlay={this.onClickHamburger} />,
      <header key='header'
        className={`h3 ph3 ph5-l pv3 absolute absolute--fill z-5 ${textColor}`}
      >
        <div className='center flex h-100 items-center justify-center justify-between-l mw-page pv1 relative'>
          <div className='dn-l absolute left-0'
            style={{
              top: '50%',
              transform: 'translateY(-50%)',
            }}
          >
            <Hamburger isOpaque={this.props.isOpaque} onClick={this.onClickHamburger} />
          </div>
          <Logo.Big isOpaque={this.props.isOpaque} />
          <Logo.Small isOpaque={this.props.isOpaque} />
          <Links color={textColor} />
        </div>
      </header>,
      this.props.isOpaque ? <div key='margin' className='h3' /> : null,
    ]
  }
}
